import Vue from 'vue'
import Router from 'vue-router'

import Block from '@/components/Block'
import Address from '@/components/Address'
import NotFound from '@/components/NotFound'
import Overview from '@/components/Overview'
import Transaction from '@/components/Transaction'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', name: 'Overview', component: Overview, props: true },
    { path: '/tx/:id', name: 'Transaction', component: Transaction },
    { path: '/block/:id', name: 'Block', component: Block },
    { path: '/address/:id', name: 'Address', component: Address },
    { path: '*', name: 'NotFound', component: NotFound }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found')
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js